import { Component, Input, OnInit } from '@angular/core';
import { AppState } from '@capacitor/app';
import { AlertController, ModalController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { cancelRide } from 'src/app/store/actions/premium-ride.action';
import { setLoadingSpinner } from 'src/app/store/actions/shared.actions';

@Component({
  selector: 'app-create-appointment-success',
  templateUrl: './create-appointment-success.component.html',
  styleUrls: ['./create-appointment-success.component.scss'],
})
export class CreateAppointmentSuccessComponent implements OnInit {

  @Input() item: any; 
  @Input() type: any;

  constructor(
    private store: Store<AppState>,
    private modalController: ModalController,
    private alertCtrl: AlertController
  ) { }

  ngOnInit() {
    console.log(this.item);
  }

  dismiss(){
    this.modalController.dismiss();
  }

}
